import { render, staticRenderFns } from "./headList.vue?vue&type=template&id=9911416a&scoped=true"
import script from "./headList.vue?vue&type=script&lang=js"
export * from "./headList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9911416a",
  null
  
)

export default component.exports